import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CompanyHolidayFormComponent } from '../company-holiday-form/company-holiday-form.component';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';
import { FormsModule } from '@angular/forms';
import * as XLSX from 'xlsx';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { SessionService } from '../../../Util/Session/session.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
@Component({
  selector: 'app-company-holiday',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, FormsModule],
  templateUrl: './company-holiday.component.html',
  styleUrl: './company-holiday.component.scss'
})
export class CompanyHolidayComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  CompanyData: any[] = [];
  Years = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  filter = {
    HistoryYear: 0
  }
  // HYear?: string
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private sessionService: SessionService,
    private download: DownloadSampleService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.SelectDate('RegistrationDate', null, null)
    this.dtoptions = { ...this.common.commonDToptions }; 
  }

  HistoryFilterOnYear() {
    this.GetCompanyHolidayMaping();
  }

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.filter.HistoryYear = currentYear;
    this.GetCompanyHolidayMaping();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetCompanyHolidayMaping() {
    this.isDisabled = true;
    this.holiday.GetCompanyHoliday({ ESS_CompanyHolidayMasterID: 0, SelectType: 2, Year: this.filter.HistoryYear }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  addCompanyHoliday(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(CompanyHolidayFormComponent);
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          if (result != undefined) {
            if (result) {
              this.GetCompanyHolidayMaping();
            }
          }
        },
        () => { }
      );
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  //Added By Pooja on 10th May 2024 As per discussion with Sakshi 
  handleFileInput(event: any): void {
    this.CompanyData = [];
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueCompanyHolidayIds: Set<number> = new Set();
        this.CompanyData = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          const id = rowData['ESS_CompanyHolidayID'];
          const date = rowData['Date'];
          let holidayName = rowData['HolidayName'].toString();
          let year = rowData['Year'];

          holidayName = holidayName ? holidayName.trim() : '';

          if (id !== 0 && id !== '' && id !== undefined && uniqueCompanyHolidayIds.has(id)) {
            this.toast.show({ message: `Duplicate CompanyHoliday ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (year.toString().length != 4 || year === '' || year === null || year === undefined) {
            this.toast.show({ message: `Invalid Year is at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (typeof date !== 'string' || date === undefined || date === null) {
            this.toast.show({ message: `Date Format should be in 'DD MMM YYYY' at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (holidayName === '' || holidayName === null || holidayName === undefined) {
            this.toast.show({ message: `Holiday name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }

          else {
            uniqueCompanyHolidayIds.add(id);
          }

          rowData['HolidayName'] = holidayName;
          rowData['ESS_CompanyHolidayID'] = id ?? '';
          this.CompanyData.push(rowData);
        }

        this.BulkInsertUpdate(this.CompanyData);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.CompanyData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const CompanyHolidayData = {
      SelectType: 'upload',
      ESS_CompanyHolidayInsert: Data,
      UserId: this.User.UserId,
    };
    this.holiday.BulkCompanyHolidayInsertUpdate(CompanyHolidayData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.GetCompanyHolidayMaping();
      },
      error => {
        console.error('Error:', error);
      });
  }
  downloadExcel() {
    this.download.downloadExcel('CompanyHolidayMaster');
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'CompanyHolidayExcel',
      Year: this.filter.HistoryYear
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.CompanyData = data;
        if (this.CompanyData.length > 0) {
          this.download.exportToExcel(this.CompanyData, "CompanyHoliday_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}
